import React, { useEffect } from "react";
import { withSpan } from "../../../Apm";
import { Card, CardHeader, CardMedia, Button } from "@mui/material";
import ruleStatementBuilder from "../../../rule-builder";
import { Translate, getTranslation } from "orion-components/i18n";
import { useDispatch, useSelector } from "react-redux";
import { getWidgetState } from "orion-components/Profiles/Selectors";
import { getDir } from "orion-components/i18n/Config/selector";
import { loadProfile } from "orion-components/ContextPanel/Actions";
import { unsubscribeFromFeed } from "orion-components/ContextualData/Actions";
import { getSelectedContextData } from "orion-components/Profiles/Selectors";
import { collectionsSelector, feedEntitiesByTypeSelector } from "orion-components/GlobalData/Selectors";
import WidgetMenu from "./components/WidgetMenu";
import { getRuleConditionsByConditionId } from "orion-components/GlobalData/Selectors";

const RulesWidget = ({ id, contextId, subscriberRef, expanded, canViewRules, canManage, hasLinks, selected }) => {
	const dispatch = useDispatch();
	const enabled = useSelector((state) => getWidgetState(state)(id, "enabled"));
	const dir = useSelector((state) => getDir(state));
	const user = useSelector((state) => state.session.user);
	const { appSettings } = user?.profile || {};
	const { appOpeningBehavior = "sameWindow" } = appSettings || {};

	const userId = useSelector((state) => state?.session?.user?.profile?.id);
	const roleIds = useSelector((state) => state?.session?.user?.profile?.roleIds);
	const entity = useSelector((state) => getSelectedContextData(state)(contextId, "entity")) || {};
	const rules = useSelector((state) => getSelectedContextData(state)(contextId, "rules")) || {};
	const { entityType } = entity || { entityType: "" };
	const collections = useSelector((state) => entity && collectionsSelector(state));
	const shapes = useSelector((state) => feedEntitiesByTypeSelector("shapes")(state)) || [];

	useEffect(() => {
		return () => {
			if (!expanded) dispatch(unsubscribeFromFeed(contextId, "rules", subscriberRef));
		};
	}, []);

	const hideButton = (entityType, entity) => {
		if (
			entityType === "shapes" &&
			entity.entityData.type === "LineString" &&
			entity.entityData.geometry.coordinates.length > 2
		) {
			return true;
		} else if (entityType === "shapes" && !entity.isPublic) {
			return true;
		} else {
			return false;
		}
	};

	const dispatchLoadProfile = (...args) => {
		dispatch(loadProfile(...args));
	};

	const cardStyles = {
		card: {
			marginBottom: ".75rem"
		},
		header: {
			backgroundColor: "#41454A",
			maxHeight: 50,
			display: "flex",
			alignItems: "center",
			padding: 8
		},
		media: {
			borderLeft: "1px solid #41454A",
			borderRight: "1px solid #41454A",
			borderBottom: "1px solid #41454A"
		},
		viewRuleButton: {
			fontSize: 12
		}
	};

	const addRule = () => {
		const ruleUrl = `/rules-app/#/create/track-movement?${entity.entityType === "shapes" ? "createTargets" : "createSubjects"
			}=${contextId}`;

		window.open(ruleUrl, "_blank");
	};

	const ruleConditionsById = useSelector((state) => getRuleConditionsByConditionId(state));

	return selected || !enabled ? (
		<div />
	) : (
		<section className={`rules-widget widget-wrapper  ${expanded ? "expanded" : "collapsed"}`}>
			{!expanded && (
				<div className="widget-header">
					<div className="cb-font-b2">
						<Translate value="global.profiles.widgets.rules.title" />
					</div>
					<div className="widget-header-buttons">
						<WidgetMenu
							dir={dir}
							canAddRule={!hideButton(entityType, entity) && canManage}
							addRule={addRule}
						/>
					</div>
				</div>
			)}

			{rules !== undefined && rules.length > 0 ? (
				<div className="widget-content">
					{rules
						.filter(
							(rule) =>
								rule.owner === userId || rule.assignments?.find((roleId) => !!roleIds.includes(roleId))
						) // check if the rule is created by the user or user is subscribed to the rule.
						.map((rule) => {
							const { ownerName, id, title, ruleSubscriptions } = rule;
							const notifyEmail = ruleSubscriptions?.find(
								(subscription) => subscription.ruleId === rule.id
							)?.email;

							return (
								<Card style={cardStyles.card} class="rule-card-header" key={id}>
									<CardHeader
										style={cardStyles.header}
										actAsExpander={true}
										iconStyle={{ float: "left" }}
										showExpandableButton={true}
										title={title}
									/>
									<CardMedia style={cardStyles.media} expandable={true}>
										<section>
											<div className="notify-types">
												{notifyEmail && <i className="material-icons">email</i>}
												<div
													className="widget-option-button"
													style={
														dir == "rtl"
															? {
																marginRight: "auto"
															}
															: {
																marginLeft: "auto"
															}
													}
												>
													{canViewRules && (
														<Button
															style={cardStyles.viewRuleButton}
															variant="text"
															color="primary"
															onClick={() =>
																window.open(`/rules-app/#/rule/${id}`, "_blank")
															}
														>
															{getTranslation("global.profiles.widgets.rules.viewRule")}
														</Button>
													)}
												</div>
											</div>
										</section>
										<section className="rule-info">
											<p className="cb-font-b7 clear">
												<Translate
													value="global.profiles.widgets.rules.createdBy"
													count={ownerName}
												/>
											</p>
											{ruleStatementBuilder(
												{ ...rule, ruleConditionsById: ruleConditionsById },
												collections,
												shapes,
												dispatchLoadProfile,
												hasLinks
											)}
										</section>
									</CardMedia>
								</Card>
							);
						})}
				</div>
			) : (
				<div />
			)
			}
		</section >
	);
};

export default withSpan("rules-widget", "profile-widget")(RulesWidget);
